import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { baseGrid } from '@helpers/grid';
import { Device, from, until } from '@helpers/media';
import { contentStyles, h3, h5, headingStyles } from '@helpers/typography';
import ButtonStyles from '@stories/Components/Buttons/Button/Button.styles';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  margin: 0;
  padding: ${fluid(40, 80)} 0;
  background-color: ${brand.primary.blueGrey};
  position: relative;
`;
const ShapeWrapper = styled.div `
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow: hidden;
  z-index: -1;

  &::before {
    ${transition('transform')};

    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    display: block;
    content: '';
    width: min(80vw, 1420px);
    aspect-ratio: 1;
    border-radius: 100%;
    background-color: ${brand.secondary.lightGrey};
    transform: translate(-10%, 50%);
  }

  @media ${until(Device.TabletLarge)} {
    display: none;
  }
`;
const Inner = styled.div `
  @media ${from(Device.TabletLarge)} {
    ${baseGrid}
    place-items: flex-start;
  }
`;
const Aside = styled.aside `
  margin-bottom: 40px;

  @media ${from(Device.TabletLarge)} {
    grid-column: 1 / span 9;
    height: 100%;
    margin-bottom: unset;
    padding-right: ${fluid(12, 16)};
  }

  ${ButtonStyles.Text} {
    white-space: initial;

    @media ${until(Device.TabletLarge)} {
      text-align: center;
    }
  }
`;
const StickyContainer = styled.div `
  @media ${from(Device.TabletLarge)} {
    position: sticky;
    left: 0;
    top: calc(var(--headerHeight) + var(--sectionSpacing));
  }
`;
const SideNavigation = styled.nav `
  margin-top: ${fluid(20, 58)};
`;
const List = styled.ul `
  display: flex;
  flex-direction: column;
  place-content: flex-start;
  gap: 24px;
`;
const Item = styled.li `
  position: relative;
  ${transition('padding-left', 0.3)}

  &:hover {
    padding-left: 10px;
  }

  &[aria-current='true'] {
    padding-left: 40px;

    &::before {
      transform: scaleX(1) translateY(-50%);
    }
  }

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    width: 26px;
    height: 3px;
    background-color: ${brand.primary.orange};
    transform: scaleX(0) translateY(-50%);
    transform-origin: left;
    pointer-events: none;
    ${transition('transform', 0.3)}
  }
`;
const Link = styled.a `
  ${fonts.apparat.medium}
  color: currentColor;
  text-decoration: none;

  [aria-current='true'] & {
    ${fonts.apparat.semiBold}
  }
`;
const Subtitle = styled.p `
  ${fonts.apparat.medium}

  font-size: ${fluid(18, 24)};
  line-height: ${fluid(28, 34)};
  opacity: 0.5;
  margin: 0 0 24px;
`;
const Title = styled.h2 `
  ${headingStyles};

  font-size: ${fluid(25, 40)};
  line-height: var(--titleLineHeight);
  margin: 0 0 ${fluid(24, 40)} !important;

  h1& {
    ${h3};
  }
`;
const ContentWrapper = styled.div `
  @media ${from(Device.TabletLarge)} {
    grid-column: 10 / span 15;
  }
`;
const Section = styled.section `
  --titleLineHeight: ${fluid(35, 50)};

  scroll-margin-top: calc(var(--scrollOffset, 0px) + var(--titleLineHeight));

  &:not(:last-of-type) {
    margin-bottom: ${fluid(40, 80)};
  }
`;
const SectionTitle = styled.h3 `
  ${h3}

  @media ${from(Device.TabletLarge)} {
    ${h5}
  }
`;
const AccordionAnswer = styled.div `
  > div {
    ${contentStyles};

    p {
      font-size: ${fluid(18, 20)};
      line-height: ${fluid(28, 30)};
    }
  }
`;
const FAQsStyles = {
    AccordionAnswer,
    Aside,
    Container,
    ContentWrapper,
    Inner,
    Item,
    Link,
    List,
    Section,
    SectionTitle,
    ShapeWrapper,
    SideNavigation,
    StickyContainer,
    Subtitle,
    Title,
};
export default FAQsStyles;
